"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var offers_nudge_1 = require("./offers_nudge");
var offers_nudge_v2_1 = require("./offers_nudge_v2");
var offers_currency_conversion_1 = require("./offers_currency_conversion");
var rql_1 = require("../rql");
var form_group_1 = require("../components/form_group");
var form_group_with_input_1 = require("../components/form_group_with_input");
var offer_notices_1 = require("./offer_notices");
var controlled_checkbox_1 = require("../components/controlled_checkbox");
var offer_amount_inputs_1 = require("./offer_amount_inputs");
var bind_1 = require("../bind");
var controlled_input_1 = require("../components/controlled_input");
var shipping_region_1 = require("./shipping_region");
var currency_1 = require("../currency");
var OfferCreateFormFields = /** @class */ (function (_super) {
    tslib_1.__extends(OfferCreateFormFields, _super);
    function OfferCreateFormFields(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            agreementChecked: _this.props.initialAgreementChecked,
        };
        return _this;
    }
    Object.defineProperty(OfferCreateFormFields.prototype, "shippingPriceInShopCurrency", {
        // This can return undefined if this is an initial offer and the listing does
        // not ship to the buyer's shipping region. In this scenario we are vague
        // about the shipping price (eg "+ Shipping")
        get: function () {
            var prices = this.props.listing.shipping.shippingPrices;
            if (prices.length > 0) {
                return prices[0].originalRate;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateFormFields.prototype, "messageLabel", {
        get: function () {
            if (this.props.party === rql_1.core_apimessages_NegotiationParty.SELLER) {
                return I18n.t('commons.offers.sellerMessageLabel');
            }
            return I18n.t('commons.offers.buyerMessageLabel');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfferCreateFormFields.prototype, "showTaxAtCheckoutNotice", {
        get: function () {
            var shippingRegionCode = lodash_1.get(this.props.listing, 'shipping.shippingRegionCode');
            return this.props.party === rql_1.core_apimessages_NegotiationParty.BUYER &&
                (!shippingRegionCode || shipping_region_1.isUSSubregion(shippingRegionCode));
        },
        enumerable: true,
        configurable: true
    });
    OfferCreateFormFields.prototype.renderOfferError = function () {
        if (!this.props.error) {
            return null;
        }
        return (React.createElement("p", { className: "offers-form__error" }, this.props.error));
    };
    OfferCreateFormFields.prototype.renderNotices = function () {
        var shop = this.props.listing.shop || { name: '' };
        var OtherNotices = this.props.notices;
        return (React.createElement("div", { className: "offers-form__notices" },
            React.createElement(offer_notices_1.CombinedSaleAndShippingNotice, { listing: this.props.listing }),
            this.props.party === rql_1.core_apimessages_NegotiationParty.BUYER &&
                React.createElement(offer_notices_1.TimelineNotice, { shop: shop }),
            this.showTaxAtCheckoutNotice && React.createElement(offer_notices_1.SalesTaxNotice, { shop: shop }),
            OtherNotices && React.createElement(OtherNotices, { listing: this.props.listing, party: this.props.party })));
    };
    OfferCreateFormFields.prototype.handleTermsCheckboxUpdate = function () {
        this.setState({ agreementChecked: !this.state.agreementChecked });
    };
    Object.defineProperty(OfferCreateFormFields.prototype, "labelTaxHint", {
        get: function () {
            if (this.props.listing.taxIncluded) {
                return " (" + this.props.listing.taxIncludedHint + ")";
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    OfferCreateFormFields.prototype.renderMessageForm = function () {
        if (this.props.messageInput) {
            return this.props.messageInput;
        }
        return (React.createElement(controlled_input_1.default, { className: "offers-form__message__textarea", updateField: this.props.onOfferChange, inputType: "textarea", fieldName: "message", inputName: "message", inputValue: this.props.offer.message, required: false }));
    };
    OfferCreateFormFields.prototype.renderOfferNudge = function () {
        if (this.props.party !== rql_1.core_apimessages_NegotiationParty.BUYER) {
            return null;
        }
        if (this.props.showNewOfferNudge) {
            return (React.createElement(offers_nudge_v2_1.default, { offer: this.props.offer, onOfferChange: this.props.onOfferChange, originalPrice: this.props.listing.price.amount }));
        }
        return (React.createElement(offers_nudge_1.default, { offerAmount: this.props.offer.price, originalAmount: this.props.listing.price.amount, currency: this.props.currency }));
    };
    OfferCreateFormFields.prototype.render = function () {
        var shop = this.props.listing.shop;
        var currencyDescription = currency_1.default.get(this.props.currency);
        return (React.createElement("div", null,
            this.renderOfferError(),
            React.createElement(offer_amount_inputs_1.default, { offer: this.props.offer, listing: this.props.listing, party: this.props.party, action: rql_1.core_apimessages_NegotiationAction.CREATE, currency: this.props.currency, taxable: this.props.listing, onOfferChange: this.props.onOfferChange, autoFocus: this.props.autoFocus }),
            this.renderOfferNudge(),
            this.props.party === rql_1.core_apimessages_NegotiationParty.SELLER &&
                React.createElement(form_group_with_input_1.default, { label: I18n.t('commons.offers.label.shipping'), fieldName: "shippingPrice", inputName: "offer-shipping-price", currencyPrefix: currencyDescription.symbol, value: this.props.offer.shippingPrice, updateField: this.props.onOfferChange, disabled: false, numberOnly: true, required: true }),
            React.createElement(offers_currency_conversion_1.default, { offerAmount: this.props.offer.price, shippingPrice: this.shippingPriceInShopCurrency, rates: this.props.exchangeRates, userCurrency: this.props.currency, shopCurrency: shop.currency }),
            React.createElement(form_group_1.default, { label: this.messageLabel, tagOptional: true }, this.renderMessageForm()),
            this.renderNotices(),
            this.props.party === rql_1.core_apimessages_NegotiationParty.BUYER &&
                React.createElement("div", { className: "offers-form__terms" },
                    React.createElement(controlled_checkbox_1.default, { checked: this.state.agreementChecked, fieldName: "offers-form-terms-checkbox", inputName: "offers-form-terms-checkbox", required: true, updateField: this.handleTermsCheckboxUpdate }),
                    React.createElement("label", { htmlFor: "offers-form-terms-checkbox" }, I18n.t('commons.offers.terms')))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], OfferCreateFormFields.prototype, "handleTermsCheckboxUpdate", null);
    return OfferCreateFormFields;
}(React.Component));
exports.default = OfferCreateFormFields;
//# sourceMappingURL=offer_create_form_fields.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offer_create_form_fields.js
// module id = LKeZ
// module chunks = 20 21